export default __webpack_public_path__ + "static/media/ava.66bec937.svg";